<form [formGroup]="settlorForm" (ngSubmit)="submitForm()" class="tab-form" autocomplete="off" novalidate>
  <div class="form-80">
    <h1 class="blue margin">{{ formTitle }}</h1>
    <p class="lead rocal">{{ formSubtitle }}</p>

    <!-- Panel 1: Contact Info -->
    <ng-template #contactInfo let-index="index">
      <div *ngIf="getSettlorFormGroup(index)">
        <div class="line-section"></div>
        <div class="row-alt">
          <div class="row-mini">
            <app-input [formGroup]="getSettlorFormGroup(index)" controlName="Title" label={{titleLabel}}
              hint={{titleHint}} required="false" inputType="auto-complete" [loadingOptions]="loadingTitles"
              [ArrayItems]="TitleOptions" [validationMessages]="validationMessages" [formErrors]="formErrors">
            </app-input>

            <app-input [formGroup]="getSettlorFormGroup(index)" controlName="FirstName" label={{fNameLabel}}
              hint={{fNameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>

          <div class="row-mini">
            <app-input [formGroup]="getSettlorFormGroup(index)" controlName="MiddleName" label={{mNameLabel}}
              hint={{mNameHint}} required='false' [validationMessages]="validationMessages"
              [formErrors]="formErrors"></app-input>
            <app-input [formGroup]="getSettlorFormGroup(index)" controlName="LastName" label={{surnameLabel}}
              hint={{surnameHint}} [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          </div>
        </div>

        <div class="row">
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="Phone" label={{phoneLabel}}
            inputType="phone" [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>

          <app-input [formGroup]="getSettlorFormGroup(index)" controlName="SecondaryPhone" class="grid-item"
            *ngIf="region === 1" label="Secondary Phone Number" inputType="phone" required="false"
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <!-- Kenya only email input -->
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="Email" *ngIf="region === 0"
            label={{emailLabel}} hint={{emailLabel}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

        <div class="row" [ngClass]="{half: region === 0}">
          <!-- Diaspora email input -->
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="Email" *ngIf="region === 1"
            label={{emailLabel}} hint={{emailLabel}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="IDNo" label={{idLabel}}
            hint={{idHint}} [validationMessages]="validationMessages" [formErrors]="formErrors">
          </app-input>
        </div>
      </div>
    </ng-template>

    <!-- Panel 2: Details -->
    <ng-template #details let-index="index">
      <div *ngIf="getSettlorFormGroup(index)">
        <div class="line-section"></div>
        <div class="row">
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="KraPin"
            label={{kraPinLabel}} hint={{kraPinHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="Address"
            label={{addressLabel}} hint={{addressHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>

        <div class="row half">
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="PostalAddress"
            label={{postalLabel}} hint={{postalHint}} [validationMessages]="validationMessages"
            [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>

    <!-- Panel 3: Upload Documents -->
    <ng-template #uploadDocs let-index="index">
      <div *ngIf="getSettlorFormGroup(index)">
        <div class="line-section"></div>
        <div class="row">
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="IDNoImage"
            label={{idFileLabel}} [fileFunction]="updateIDObject.bind(this, index)" inputType="file"
            [existingFileName]="settlors[index]?.IDNoImage?.name != '' ? settlors[index]?.IDNoImage?.name : '' "
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="KraPinImage"
            label={{kraFileLabel}} [fileFunction]="updateKraObject.bind(this, index)" inputType="file"
            [existingFileName]="settlors[index]?.KraPinImage?.name != '' ? settlors[index]?.KraPinImage?.name : '' "
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>
        <div class="row half">
          <app-input [formGroup]="getSettlorFormGroup(index)" class="grid-item" controlName="PassportImage"
            label={{photoLabel}} [fileFunction]="updatePhotoObject.bind(this, index)" inputType="file"
            [existingFileName]="settlors[index]?.PassportImage?.name != '' ? settlors[index]?.PassportImage?.name : '' "
            [validationMessages]="validationMessages" [formErrors]="formErrors"></app-input>
        </div>
      </div>
    </ng-template>


    <div formArrayName="settlors">
      <div *ngFor="let settlor of getSettlors().controls; let i=index" [formGroupName]="i" style="position: relative;">

        <div style="height: 40px;" *ngIf="i > 1"></div>
        <p style="font-weight: 600; font-size: 1.4em; margin-left: 8px;" class="margin"
          *ngIf="getSettlors().length > 1">
          {{'Settlor ' + (i+1) +(i==0 ? ' (Primary)' : '')}}
        </p>

        <!-- Accordion -->
        <app-section [panels]="settlorsPanels[i]" style="display: flex; box-sizing: border-box;">
        </app-section>

        <div class="action-buttons">
          <button *ngIf="i > 0" mat-stroked-button type="button" class="remove" (click)="removeSettlor(i)">
            <div style="display: flex; flex: 1; align-items: center;">
              <span class="button-text">
                <u>{{ getSettlors().controls.length-1 === i ? removeButtonText : removeSettlorText
                  }}</u>
              </span>
              <span class="spinning-global" *ngIf="currentIndex === i && loadingRemove">
                <mat-progress-spinner mode="indeterminate" diameter="25" strokeWidth="4">
                </mat-progress-spinner>
              </span>
            </div>
          </button>

          <button class="update" mat-stroked-button type="button" *ngIf="getSettlors() && !confirmFormMatchesRecord(i)"
            [disabled]="loading || loadingRemove" (click)="updateRecord(i)">
            <span class="button-text">
              {{ 'Update settlor ' +(i+1) }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- BUTTTON Add Settlor -->
    <div class="blueStroke row" style="margin-top: 16px;" [ngClass]="{'min-55' : getSettlors().length > 1}">
      <button mat-stroked-button *ngIf="settlors[settlors.length-1] && settlors[settlors.length-1].done === true"
        [disabled]="loading || loadingRemove" class="general-stroked-button" type="button" (click)="addNewSettlor()">
        <span class="button-text">
          {{ addSettlorText }}
        </span>
      </button>
    </div>
  </div>

  <!-- BOTTOM OF FORM -->
  <app-form-bottom style="width: 100%;" [service]="estateControlService" [text]="
            loading ? loadingText :
            settlors[settlors.length-1] && settlors[settlors.length-1].done == true ? 'Next' :
            settlors[settlors.length-1] && settlors[settlors.length-1].verified == false ? 'Verify via OTP' :
            !consentProvided && settlors.length <= 1 ? 'Terms and Data Privacy' : 'Save Details'" [formValid]="
            settlors[settlors.length-1] && settlors[settlors.length-1].done ? true :
            settlorForm.valid ? true : false" [showContinue]="'false'" [buttonClickHandler]="submitForm.bind(this)">
  </app-form-bottom>
</form>